import { Card, Divider, List } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { Company } from '../../../models/company-interface';
import { CompanyParentChildren } from '../../../models/company-parent-child-interface';

interface ParentChildrenCardProps {
  parentChildren: CompanyParentChildren | undefined;
}

export function ParentChildrenCard({ parentChildren }: ParentChildrenCardProps) {
  if (!parentChildren || (!parentChildren.Parent && !parentChildren.Children?.length)) return null;

  return (
    <Card>
      <ParentBoard parent={parentChildren.Parent} />
      {!!parentChildren.Parent && !!parentChildren.Children?.length && <Divider style={{ marginTop: 0 }} />}
      <ChildrenBoards children={parentChildren.Children} />
    </Card>
  );
}

const ParentBoard = ({ parent }: { parent: Company | undefined }) => {
  if (!parent) return null;

  return (
    <>
      <b>PARENT BOARD</b>
      <List
        size='large'
        dataSource={[parent]}
        renderItem={(item) => (
          <List.Item>
            <Link to={`/admin/company/${item.id}`}>{item.name}</Link>
          </List.Item>
        )}
      />
    </>
  );
};

const ChildrenBoards = ({ children }: { children: Company[] | undefined }) => {
  if (!children?.length) return null;

  return (
    <>
      <b>CHILD BOARDS</b>
      <List
        size='large'
        dataSource={children}
        renderItem={(item) => (
          <List.Item>
            <Link to={`/admin/company/${item.id}`}>{item.name}</Link>
          </List.Item>
        )}
      />
    </>
  );
};
